// ============================================
// SMSCompliance.jsx - PARENT COMPONENT (FULL FILE)
// ============================================

import React, { useEffect, useRef, useState } from "react";
import { useForm, FormProvider, Controller } from "react-hook-form";
import {
  MDBContainer,
  MDBCard,
  MDBCardBody,
  MDBBtn,
  MDBBadge,
  MDBIcon,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBScrollspy,
  MDBScrollspyLink,
  MDBAlert,
  MDBTypography,
  MDBListGroupItem,
  MDBCheckbox,
  MDBListGroup,
  MDBSpinner,
} from "mdb-react-ui-kit";
import BusinessRegistrationForm from "./BusinessRegistrationForm";
import SmsCampaignForm from "./SmsCampaignForm";
import SMSCampaignPhoneNumber from "./SMSCampaignPhoneNumber";
import {
  createSMSBrandCampaign,
  draftSMSBrandCampaign,
  // getSMSAttributes,
  getSpecificSMSBrandDetails,
  getMisc,
} from "../../apiclients/streamsapi_bridge";
import isEqual from "lodash.isequal";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import SMSStatusAlert from "../../components/SMSStatusAlert";
import PopupLoader from "../popups/PopupLoader";
import TextareaAutosize from "react-textarea-autosize";
import SampeAIChecksPOPUP from "./SampeAIChecksPOPUP";
import { api_serverUrl } from "../../apiclients/apiurls";
const msaURL =
  JSON.parse(sessionStorage.getItem("admin_session"))?.msaURL ?? "";

// Default form data structure based on the JSON payload
const getDefaultFormData = () => ({
  brand_id: "",
  brand_details: {
    contact_name: "",
    email: "",
    phno: "",
    company_name: "",
    brand_name: "",
    tax_number: "",
    country: "",
    org_type: "",
    vertical_type: "",
    website: "",
    street: "",
    city: "",
    state: "",
    zipcode: "",
    brand_unqid: 0,
    // stock_exchange: "",
    // stock_symbol: "",
  },
  campaign_details: {
    campaign_name: "",
    campaign_unqid: 0,
    embed_link: false,
    embed_phno: false,
    age_content: false,
    brand_id: "",
    usecases: {
      case: 0,
      subcase: [],
    },
    camp_desc: {
      desc: "",
      optin_desc: "",
      optout_desc: "",
      help_desc: "",
      // msg_flow: "",
      cmp_usage: 1,
      smpl_msgs: [
        { id: 1, msg_txt: "" },
        { id: 2, msg_txt: "" },
      ],
      consent_msg: "",
      msg_flow_chk: false,
    },
  },
  ph_numbers: {
    add_phnums: [],
    bulk_phnums: [],
  },
  terms: false,
  location_id: 0,
  billing_group_id: 1,
});

export default function SmsCompliance({
  brandMiscInfo,
  closePopup,
  draftDetails,
  basicActive,
}) {
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDraftSaving, setIsDraftSaving] = useState(false);
  const { t, i18n } = useTranslation();
  const [brandInfo, setBrandInfo] = useState({});
  const [campaignMisc, setCampaignMisc] = useState({});
  const [phoneNumList, setPhoneNumList] = useState([]);
  const [allLocations, setAllLocations] = useState([]);
  const [billingGroupList, setBillingGroupList] = useState([]);
  const [accepted, setAccepted] = useState(false);
  const [savedDraftData, setsavedDraftData] = useState({});
  const [isChanged, setIsChanged] = useState(false);
  const [isDraft, setisDraft] = useState(false);
  const [isOpen, setisOpen] = useState(false);
  const openPopup = () => setisOpen(!isOpen);
  const [brandUniqueId, setbrandUniqueId] = useState(0);
  const navigate = useNavigate();
  const [successMessage, setSuccessMessage] = useState("");
  const [showFullForm, setShowFullForm] = useState(false);
  const [showStatusAlert, setShowStatusAlert] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [statusAlertType, setStatusAlertType] = useState("pending");
  const [isloading, setIsloading] = useState(false);
  const [warningAlert, setwarningAlert] = useState(false);
  const toggleWarning = () => setwarningAlert(!warningAlert);
  const [warningAlertMessage, setwarningAlertMessage] = useState("");
  const [failureAlert, setfailureAlert] = useState(false);
  const [confirmAlert, setconfirmAlert] = useState(false);
  const toggleConfirm = () => setconfirmAlert(!confirmAlert);
  const [FailureMessage, setFailureMessage] = useState("");
  const toggleFailure = () => setfailureAlert(!failureAlert);
  const [failureconfirm, setfailureConfirm] = useState(false);
  const toggleFailureConfirm = () => setfailureConfirm(!failureconfirm);
  const [aiReviewSummary, setaiReviewSummary] = useState(false);
  const [draftsuccess, setdraftsuccess] = useState(false);
  const [aiResults, setAiResults] = useState({
    embedded_link: false,
    embedded_phnum: false,
    age_gated: false,
  });

  // State for brand name and website replacement
  const [brandNameForReplacement, setBrandNameForReplacement] =
    useState("[CustomerName]");
  const [websiteForReplacement, setWebsiteForReplacement] =
    useState("[customerwebsite]");

  // Initialize react-hook-form with proper FormProvider pattern
  const methods = useForm({
    defaultValues: getDefaultFormData(),
    mode: "onChange",
    shouldFocusError: false, // Manual focus management to avoid scroll conflicts
  });

  const {
    handleSubmit,
    getValues,
    reset,
    formState: { isDirty, dirtyFields, errors },
    setFocus,
    setError,
    watch,
    setValue,
  } = methods;

  // Function to process brand name value
  const processBrandNameValue = (brandName) => {
    if (!brandName || brandName.trim() === "") {
      return "[CustomerName]";
    }
    return brandName.trim();
  };

  // Step validation functions
  const isStep1Complete = () => {
    const brandDetails = watch("brand_details");
    const brandsId = watch("brand_id");
    const orgTpe =
      watch("brand_details.org_type") &&
        parseInt(watch("brand_details.org_type")) === 1
        ? true
        : false;

    // Check if dropdown selection exists
    if (brandsId && String(brandsId).trim() !== "") {
      return true;
    }

    // Check if all required form fields are filled
    const requiredFields = [
      "contact_name",
      "email",
      "phno",
      "company_name",
      "brand_name",
      "tax_number",
      "country",
      "org_type",
      "vertical_type",
      "zipcode",
      "website",
      "street",
      "city",
      "state",
      // ...(orgTpe ? ["stock_exchange", "stock_symbol"] : []),
    ];

    return requiredFields.every(
      (field) =>
        brandDetails?.[field] && String(brandDetails[field]).trim() !== "",
    );
  };

  const isStep2Complete = () => {
    const campaignDetails = watch("campaign_details");
    // const campaignName = campaignDetails?.campaign_name;
    const subcases = campaignDetails?.usecases?.subcase || [];
    const sampleMsgs = campaignDetails?.camp_desc?.smpl_msgs || [];
    const consentMsg = campaignDetails?.camp_desc?.consent_msg ?? "";
    const campDesc = campaignDetails?.camp_desc;
    const cmpUsage = campaignDetails?.camp_desc?.cmp_usage;

    // Check campaign name
    // if (!campaignName || campaignName.trim().length < 2) return false;

    // Check campaign usage
    if (!cmpUsage || cmpUsage === "") return false;

    // Check use cases (min 1)
    if (subcases.length === 0) return false;
    if (sampleMsgs.length < 2) return false;

    for (let msg of sampleMsgs) {
      if (!msg.msg_txt || msg.msg_txt.trim().length < 20) return false;
    }

    // Check consent message (single string, min 40 chars)
    const safeConsent = typeof consentMsg === "string" ? consentMsg : "";
    if (safeConsent.trim().length < 40) return false;

    // Check required text fields (min lengths)
    const textFields = [
      { field: "desc", minLen: 40 },
      { field: "optin_desc", minLen: 20 },
      { field: "optout_desc", minLen: 20 },
      { field: "help_desc", minLen: 20 },
    ];

    for (let { field, minLen } of textFields) {
      if (!campDesc?.[field] || campDesc[field].trim().length < minLen)
        return false;
    }

    return true;
  };

  const isStep3Complete = () => {
    const addNums = watch("ph_numbers.add_phnums") || [];
    const bulkNums = watch("ph_numbers.bulk_phnums") || [];
    return addNums.length > 0 || bulkNums.length > 0;
  };

  const isStep4Complete = () => {
    return watch("terms") === true;
  };

  // Process brandMiscInfo when it changes
  useEffect(() => {
    if (brandMiscInfo && Object.keys(brandMiscInfo).length > 0) {
      setBrandInfo(brandMiscInfo?.dropDown ?? {});
      if (!draftDetails) {
        if (
          brandMiscInfo?.dropDown?.active_brands &&
          brandMiscInfo?.dropDown?.active_brands?.length === 0
        ) {
          setShowFullForm(true);
        } else {
          setShowFullForm(false);
        }
      }
      if (
        brandMiscInfo?.cmpgnmisc &&
        Object.keys(brandMiscInfo?.cmpgnmisc).length > 0
      ) {
        const { cmpNmbers, ...rest } = brandMiscInfo.cmpgnmisc;
        setCampaignMisc(rest);
        setPhoneNumList([...cmpNmbers]);
      }
    }
  }, [brandMiscInfo]);

  // Fetch Location & Billing Group dropdown data (same pattern as addUsers.js)
  useEffect(() => {
    async function fetchLocationBillingMisc() {
      try {
        const siteid = JSON.parse(
          sessionStorage.getItem("admin_session"),
        )?.siteid;
        const response = await getMisc(siteid, {
          misc: ["all_locations", "billinggroups"],
        });
        const tdata = await response.json();
        const locations = tdata?.misc?.all_locations ?? [];
        setAllLocations(locations);
        setBillingGroupList(tdata?.misc?.billinggroups ?? []);
        if (!draftDetails) {
          const defaultLocation = locations.find((loc) => loc?.default_loc);
          if (defaultLocation) {
            setValue("location_id", defaultLocation.loc_id);
          }
        }
      } catch (error) {
        // Location/Billing Group dropdowns simply render empty on failure
      }
    }
    fetchLocationBillingMisc();
  }, []);

  useEffect(() => {
    if (
      phoneNumList?.length > 0 &&
      draftDetails?.ph_numbers?.add_phnums?.length > 0
    ) {
      const filtered = draftDetails.ph_numbers.add_phnums.filter((num) =>
        phoneNumList.includes(num)
      );

      if (filtered.length !== draftDetails.ph_numbers.add_phnums.length) {
        setValue("ph_numbers.add_phnums", filtered || [], {
          shouldDirty: true,
        });

        setsavedDraftData((prev) => ({
          ...prev,
          ph_numbers: {
            ...prev.ph_numbers,
            add_phnums: filtered,
          },
        }));
      }
    }
  }, [phoneNumList, draftDetails]);

  // Save form data (with validation handled by react-hook-form)
  const onSubmit =
    (isFromOtherPlace = false, confirm = 0) =>
      async (data) => {
        if (!watch("terms")) {
          alert("Please accept the terms and conditions before submitting.");
          return;
        }
        setIsloading(true);
        try {
          let modifiedData = prepareFinalJson(dirtyFields, data);

          // 2. Force include the three boolean fields regardless of dirty status
          modifiedData.campaign_details.embed_link =
            data.campaign_details.embed_link ?? false;
          modifiedData.campaign_details.embed_phno =
            data.campaign_details.embed_phno ?? false;
          modifiedData.campaign_details.age_content =
            data.campaign_details.age_content ?? false;
          modifiedData.campaign_details.camp_desc.msg_flow_chk =
            data.campaign_details.camp_desc.msg_flow_chk ?? false;
          modifiedData.campaign_details.camp_desc.cmp_usage = data
            .campaign_details.camp_desc.cmp_usage
            ? parseInt(data.campaign_details.camp_desc.cmp_usage)
            : "";
          // Always include consent_msg so it is never absent when msg_flow_chk
          // or other fields change without the user re-typing the consent text.
          modifiedData.campaign_details.camp_desc.consent_msg =
            data.campaign_details?.camp_desc?.consent_msg ?? "";

          if (modifiedData.campaign_details?.camp_desc?.smpl_msgs) {
            modifiedData.campaign_details.camp_desc.smpl_msgs =
              modifiedData.campaign_details.camp_desc.smpl_msgs.map(
                (msg, idx) => ({
                  id: idx + 1,
                  msg_txt: msg.msg_txt,
                }),
              );
          }

          if (modifiedData && Object.keys(modifiedData).length > 0) {
            if (
              modifiedData.brand_details &&
              Object.keys(modifiedData.brand_details).length === 0
            ) {
              delete modifiedData.brand_details;
            }
            modifiedData.reqid = 161;
            modifiedData.siteid = JSON.parse(
              sessionStorage.getItem("admin_session"),
            ).siteid;
            modifiedData.is_draft = 0;
            modifiedData.location_id = data.location_id;
            modifiedData.billing_group_id = data.billing_group_id;
            if (brandUniqueId && brandUniqueId !== 0) {
              modifiedData.unique_id = brandUniqueId;
            }
            if (data.cnf_emails && data.cnf_emails.trim() !== "") {
              modifiedData.cnf_emails = data.cnf_emails
                .split(",")
                .map((email) => email.trim())
                .filter((email) => email !== "");
            } else {
              delete modifiedData.cnf_emails;
            }

            if (isFromOtherPlace) {
              modifiedData.submit_flg = true;
            }
            confirm !== undefined && (modifiedData.req_chk = confirm);
            console.log(
              "modifiedData ::::::::::::::::",
              JSON.stringify(modifiedData),
            );

            const brandid = watch("brand_id");

            let saverep = await createSMSBrandCampaign(modifiedData);
            setIsloading(false);
            console.log(`reponse of next :::: ${JSON.stringify(saverep)}`);
            let saverepeMsg = await saverep.json();
            console.log("response of next:::" + JSON.stringify(saverepeMsg));
            if (saverepeMsg.success && saverepeMsg.airesponse?.enable_keys) {
              // Store AI results in state
              if (saverepeMsg.atr_chk) {
                setaiReviewSummary(false);
                toggleConfirm();
              } else {
                setAiResults({
                  embedded_link:
                    saverepeMsg.airesponse.enable_keys.embedded_link || false,
                  embedded_phnum:
                    saverepeMsg.airesponse.enable_keys.embedded_phnum || false,
                  age_gated:
                    saverepeMsg.airesponse.enable_keys.age_gated || false,
                });

                // Update form values with AI results
                // setValue(
                //   "campaign_details.embed_link",
                //   saverepeMsg.airesponse.enable_keys.embedded_link || false,
                //   { shouldDirty: true }
                // );
                // setValue(
                //   "campaign_details.embed_phno",
                //   saverepeMsg.airesponse.enable_keys.embedded_phnum || false,
                //   { shouldDirty: true }
                // );
                // setValue(
                //   "campaign_details.age_content",
                //   saverepeMsg.airesponse.enable_keys.age_gated || false,
                //   { shouldDirty: true }
                // );

                // Open AI Review Summary modal
                setaiReviewSummary(true);
              }
            } else if (saverepeMsg.status && saverepeMsg.status == "success") {
              localStorage.setItem("b_message", saverepeMsg.message);
              reset();
              setCurrentStep(1);
              if (isFromOtherPlace) {
                navigate("/smslanding", {
                  state: { tab: "tab1" },
                });
              } else if (brandid) {
                navigate("/smslanding", {
                  state: { tab: "tab2" },
                });
              } else {
                navigate("/smslanding", {
                  state: { tab: "tab3" },
                });
              }

              window.location.reload();
            } else {
              if (saverepeMsg.message?.errors) {
                const backendErrors = {};
                saverepeMsg.message.errors.forEach((err) => {
                  setError(err.param_name, {
                    type: "server",
                    message: err.message,
                  });
                  // Populate backendErrors for unified onError logic (handling nested keys)
                  const parts = err.param_name.split(".");
                  let current = backendErrors;
                  for (let i = 0; i < parts.length; i++) {
                    const part = parts[i];
                    if (i === parts.length - 1) {
                      current[part] = { message: err.message };
                    } else {
                      current[part] = current[part] || {};
                      current = current[part];
                    }
                  }
                });
                // Trigger the smooth scroll and delayed focus sequence
                onError(backendErrors);
              } else {
                setwarningAlert(true);
                setwarningAlertMessage(saverepeMsg.message ?? "");
              }
            }
          }
        } catch (error) {
          setIsloading(false);
          console.error("Save error:", error);
          alert("Error saving form. Please try again.");
        } finally {
        }
      };

  // useEffect for draftDetails
  useEffect(() => {
    if (draftDetails && Object.keys(draftDetails).length > 0) {
      setbrandUniqueId(
        draftDetails.unique_id ? parseInt(draftDetails.unique_id) : 0,
      );
      if (draftDetails.location_id) {
        setValue("location_id", parseInt(draftDetails.location_id), {
          shouldDirty: true,
        });
      }
      if (draftDetails.billing_group_id) {
        setValue("billing_group_id", parseInt(draftDetails.billing_group_id), {
          shouldDirty: true,
        });
      }
      if (draftDetails.brand_id && draftDetails.brand_id !== "") {
        setShowFullForm(false);
        setValue("brand_id", draftDetails.brand_id, {
          shouldDirty: true,
        });

        // Set the brand name if we have the brandInfo loaded
        if (brandInfo?.active_brands) {
          const selectedBrand = brandInfo.active_brands.find(
            (brand) => brand.brand_id === draftDetails.brand_id,
          );

          if (selectedBrand?.brand_name) {
            const processedBrandName = processBrandNameValue(
              selectedBrand.brand_name,
            );
            setBrandNameForReplacement(processedBrandName);
          }
        }
      } else if (draftDetails.brand_details) {
        setShowFullForm(true);

        // Set brand name from draft details
        if (draftDetails.brand_details.brand_name) {
          const processedBrandName = processBrandNameValue(
            draftDetails.brand_details.brand_name,
          );
          setBrandNameForReplacement(processedBrandName);
        }

        Object.keys(draftDetails.brand_details).forEach((key) => {
          setValue(
            `brand_details.${key}`,
            draftDetails?.brand_details[key] ?? "",
            {
              shouldDirty: true,
            },
          );
        });
      }

      // Populate campaign details
      if (draftDetails.campaign_details) {
        setValue(
          "campaign_details.campaign_name",
          draftDetails.campaign_details.campaign_name || "",
          { shouldDirty: true },
        );
        setValue(
          "campaign_details.embed_link",
          draftDetails.campaign_details.embed_link || false,
          { shouldDirty: true },
        );
        setValue(
          "campaign_details.embed_phno",
          draftDetails.campaign_details.embed_phno || false,
          { shouldDirty: true },
        );
        setValue(
          "campaign_details.age_content",
          draftDetails.campaign_details.age_content || false,
          { shouldDirty: true },
        );

        if (draftDetails.campaign_details.usecases) {
          setValue(
            "campaign_details.usecases.subcase",
            draftDetails.campaign_details.usecases.subcase || [],
            { shouldDirty: true },
          );
        }

        if (draftDetails.campaign_details.camp_desc) {
          const campDesc = draftDetails.campaign_details.camp_desc;
          setValue("campaign_details.camp_desc.desc", campDesc.desc || "", {
            shouldDirty: true,
          });
          setValue(
            "campaign_details.camp_desc.optin_desc",
            campDesc.optin_desc || "",
            { shouldDirty: true },
          );
          setValue(
            "campaign_details.camp_desc.optout_desc",
            campDesc.optout_desc || "",
            { shouldDirty: true },
          );
          setValue(
            "campaign_details.camp_desc.help_desc",
            campDesc.help_desc || "",
            { shouldDirty: true },
          );
          // setValue(
          //   "campaign_details.camp_desc.msg_flow",
          //   campDesc.msg_flow || "",
          //   { shouldDirty: true }
          // );
          setValue(
            "campaign_details.camp_desc.cmp_usage",
            campDesc.cmp_usage || "",
            { shouldDirty: true },
          );

          const sampleMessages = campDesc.smpl_msgs || [];
          const formattedMessages =
            sampleMessages.length >= 2
              ? sampleMessages.map((msg, idx) => ({
                id: msg.id || idx + 1,
                msg_txt: msg.msg_txt || "",
              }))
              : [
                { id: 1, msg_txt: sampleMessages[0]?.msg_txt || "" },
                { id: 2, msg_txt: sampleMessages[1]?.msg_txt || "" },
              ];

          setValue("campaign_details.camp_desc.smpl_msgs", formattedMessages, {
            shouldDirty: true,
          });

          setValue(
            "campaign_details.camp_desc.consent_msg",
            typeof campDesc.consent_msg === "string" ? campDesc.consent_msg : "",
            { shouldDirty: true },
          );
          setValue(
            "campaign_details.camp_desc.msg_flow_chk",
            campDesc.msg_flow_chk || false,
            { shouldDirty: true },
          );
        }
      }

      // Populate phone numbers
      if (draftDetails.ph_numbers) {
        setValue(
          "ph_numbers.add_phnums",
          draftDetails.ph_numbers.add_phnums || [],
          { shouldDirty: true },
        );
        setValue(
          "ph_numbers.bulk_phnums",
          draftDetails.ph_numbers.bulk_phnums || [],
          { shouldDirty: true },
        );
      }
      setValue("terms", draftDetails.terms || false, { shouldDirty: true });

      // Store the same data in savedDraftData
      setsavedDraftData({
        brand_details: !draftDetails?.brand_id
          ? draftDetails.brand_details || {}
          : undefined,
        brand_id: draftDetails?.brand_id || undefined,
        campaign_details: draftDetails.campaign_details || {},
        ph_numbers: {
          add_phnums: draftDetails?.ph_numbers?.add_phnums ?? [],
          bulk_phnums: draftDetails?.ph_numbers?.bulk_phnums ?? [],
        },
        terms: draftDetails.terms || false,
      });
      if (
        draftDetails?.reason &&
        Object.keys(draftDetails?.reason).length > 0
      ) {
        if (draftDetails?.reason?.error) {
          setFailureMessage(draftDetails?.reason?.error ?? "");
          setfailureAlert(true);
        } else {
          setSelectedCampaign({
            ...draftDetails?.reason,
            status: "failed",
            brand_name: draftDetails?.brand_details?.brand_name,
            camp_name: draftDetails?.campaign_details?.campaign_name,
          });
          setShowStatusAlert(true);
          setStatusAlertType("failure");
        }
      }
    }
  }, [draftDetails, brandInfo]);

  const onError = (errors) => {
    console.log("Form Errors:", errors);

    // Determine target section and first field to focus
    let targetSection = null;
    let focusField = null;

    if (errors.brand_id) {
      targetSection = section1;
      focusField = "brand_id";
    } else if (errors.brand_details) {
      targetSection = section1;
      const firstKey = Object.keys(errors.brand_details)[0];
      focusField = `brand_details.${firstKey}`;
    } else if (errors.campaign_details) {
      targetSection = section2;
      if (errors.campaign_details.campaign_name) {
        focusField = "campaign_details.campaign_name";
      } else if (errors.campaign_details.camp_desc) {
        const descErrors = errors.campaign_details.camp_desc;
        if (descErrors.smpl_msgs) {
          const firstIndex = Object.keys(descErrors.smpl_msgs)[0];
          focusField = `campaign_details.camp_desc.smpl_msgs.${firstIndex}.msg_txt`;
        } else if (descErrors.consent_msg) {
          focusField = "campaign_details.camp_desc.consent_msg";
        } else {
          const firstKey = Object.keys(descErrors)[0];
          focusField = `campaign_details.camp_desc.${firstKey}`;
        }
      } else if (errors.campaign_details.usecases) {
        focusField = "campaign_details.usecases.subcase";
      }
    } else if (errors.ph_numbers) {
      targetSection = section3;
      focusField = "ph_numbers.add_phnums";
    } else if (errors.terms) {
      targetSection = section4;
      focusField = "terms";
    }

    if (targetSection?.current) {
      // 1. Smooth scroll to the section
      targetSection.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });

      // 2. After a short delay to allow scroll to settle, manually focus the field
      if (focusField) {
        setTimeout(() => {
          setFocus(focusField);
        }, 500);
      }
    }
  };

  // Separate useEffect to handle website fetch when draft has brand_id
  useEffect(() => {
    if (draftDetails?.brand_id && brandInfo?.active_brands) {
      handleBrandChange(draftDetails.brand_id);
    }
  }, [draftDetails?.brand_id, brandInfo?.active_brands]);

  function prepareFinalJson(dirtyFields, data) {
    const modifiedData = {};

    function recurse(dirtyFields, data, modifiedData) {
      for (const field of Object.keys(dirtyFields)) {
        if (dirtyFields[field] && data.hasOwnProperty(field)) {
          if (typeof data[field] === "object" && !Array.isArray(data[field])) {
            modifiedData[field] = {};
            recurse(dirtyFields[field], data[field], modifiedData[field]);
          } else {
            modifiedData[field] = data[field];
          }
        }
      }
    }

    recurse(dirtyFields, data, modifiedData);
    return modifiedData;
  }

  const currentValues = watch();

  useEffect(() => {
    if (!savedDraftData || !isDirty) {
      setIsChanged(false);
      if (setisDraft) {
        setisDraft(false);
      }
      return;
    }
    const changed = Object.keys(currentValues).some(
      (key) => !isEqual(currentValues[key], savedDraftData[key]),
    );

    setIsChanged(changed);
    if (setisDraft) {
      setisDraft(changed);
    }
  }, [currentValues, savedDraftData]);

  const handClose = () => {
    onSaveDraft(1);
  };

  const handleClose = (e) => {
    if (isDraft) {
      openPopup();
    } else {
      if (draftsuccess) {
        navigate("/smslanding", {
          state: { tab: "tab3" },
        });
      } else {
        navigate("/smslanding", {
          state: { tab: basicActive },
        });
      }

      window.location.reload();
    }
  };

  // Save draft (without validation, only dirty fields)
  const onSaveDraft = async (flag) => {
    setIsDraftSaving(true);
    setIsloading(true);
    try {
      const allValues = getValues();
      let modifiedData = prepareFinalJson(dirtyFields, allValues);

      if (modifiedData && Object.keys(modifiedData).length > 0) {
        if (watch("campaign_details.camp_desc.cmp_usage") == 1) {
          if (modifiedData?.campaign_details?.camp_desc) {
            modifiedData.campaign_details.camp_desc.cmp_usage = 1;
          } else {
            modifiedData.campaign_details = {
              camp_desc: {
                cmp_usage: 1,
              },
            };
          }
        }
        modifiedData.siteid = JSON.parse(
          sessionStorage.getItem("admin_session"),
        ).siteid;
        if (brandUniqueId && brandUniqueId !== 0) {
          modifiedData.unique_id = brandUniqueId;
        }
        modifiedData.location_id = allValues.location_id;
        modifiedData.billing_group_id = allValues.billing_group_id;

        if (modifiedData.campaign_details?.camp_desc?.smpl_msgs) {
          modifiedData.campaign_details.camp_desc.smpl_msgs =
            modifiedData.campaign_details.camp_desc.smpl_msgs.map(
              (msg, idx) => ({
                id: idx + 1,
                msg_txt: msg.msg_txt || "",
              }),
            );
        }

        // Always include consent_msg so it is preserved when only other fields changed.
        if (modifiedData.campaign_details?.camp_desc) {
          modifiedData.campaign_details.camp_desc.consent_msg =
            allValues.campaign_details?.camp_desc?.consent_msg ?? "";
        }

        setIsSubmitting(true);
        setIsDraftSaving(false);

        let saverep = await draftSMSBrandCampaign(modifiedData);
        setIsloading(false);
        console.log(`reponse of next :::: ${JSON.stringify(saverep)}`);
        let saverepeMsg = await saverep.json();
        console.log("response of next:::" + JSON.stringify(saverepeMsg));
        if (saverepeMsg.status && saverepeMsg.status == "success") {
          if (flag && flag === 1) {
            navigate("/smslanding", {
              state: { tab: "tab3" },
            });
            window.location.reload();
            // window.location.href = "/smslanding";
          } else {
            setSuccessMessage(saverepeMsg.message);
            setbrandUniqueId(saverepeMsg?.data?.unique_id ?? 0);
            setdraftsuccess(true);
          }
          setsavedDraftData(allValues);
        } else {
        }
      }
    } catch (error) {
      setIsloading(false);
      console.error("Draft save error:", error);
      alert("Error saving draft. Please try again.");
    } finally {
    }
  };

  // Close save function
  function closeSave(e) {
    e.preventDefault();
    reset();
  }

  const handleFinish = () => {
    navigate("/smslanding", {
      state: { tab: basicActive },
    });

    window.location.reload();
  };

  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
  const section4 = useRef(null);

  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      setTimeout(() => {
        container.scrollTo({
          top: 5,
          behavior: "smooth",
        });

        setTimeout(() => {
          container.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }, 100);
      }, 500);
    }
  }, [containerRef]);

  const websiteTimerRef = useRef(null);

  // Add this function to process the website value
  const processWebsiteValue = (value) => {
    if (!value || value.trim() === "") {
      return "[customerwebsite]";
    }

    // Remove https:// or http:// ONLY - keep everything else including the path
    let processedValue = value.replace(/^https?:\/\//, "");

    return processedValue;
  };

  // Function to handle brand name changes
  const handleBrandNameChange = (value) => {
    const processedBrandName = processBrandNameValue(value);
    setBrandNameForReplacement(processedBrandName);
  };

  const handleWebsiteChange = (value) => {
    // Clear any existing timer
    if (websiteTimerRef.current) {
      clearTimeout(websiteTimerRef.current);
    }

    // Set a new timer for 1 second
    websiteTimerRef.current = setTimeout(() => {
      const processedWebsite = processWebsiteValue(value);
      setWebsiteForReplacement(processedWebsite);
    }, 1000);
  };

  // Add cleanup effect for the timer
  useEffect(() => {
    return () => {
      if (websiteTimerRef.current) {
        clearTimeout(websiteTimerRef.current);
      }
    };
  }, []);

  async function handleBrandChange(brandid) {
    if (!brandid || brandid === "") {
      // If no brand selected, reset to placeholder
      setWebsiteForReplacement("[customerwebsite]");
      setBrandNameForReplacement("[CustomerName]");
      return;
    }

    // Get brand name from active_brands list
    const selectedBrand = brandInfo?.active_brands?.find(
      (brand) => brand.brand_id === brandid,
    );

    if (selectedBrand?.brand_name) {
      const processedBrandName = processBrandNameValue(
        selectedBrand.brand_name,
      );
      setBrandNameForReplacement(processedBrandName);
    } else {
      setBrandNameForReplacement("[CustomerName]");
    }

    // Fetch website from API
    setIsloading(true);
    try {
      const response = await getSpecificSMSBrandDetails(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        brandid,
      );
      const brandDetails = await response.json();
      // Process the website value using the same logic
      const websiteValue = brandDetails?.brand_details?.website || "";
      const processedWebsite = processWebsiteValue(websiteValue);

      setWebsiteForReplacement(processedWebsite);
    } catch (error) {
      console.error("Error fetching brand details:", error);
      setWebsiteForReplacement("[customerwebsite]");
    } finally {
      setIsloading(false);
    }
  }

  async function handleAnyWaySubmit() {
    setValue("terms", true, { shouldDirty: true });
    setfailureConfirm(false);
    setShowStatusAlert(false);
    setfailureAlert(false);

    handleSubmit(onSubmit(true))();
  }

  useEffect(() => {
    const container = containerRef.current;

    // Only run after brandMiscInfo and form data are loaded
    if (container && brandInfo && Object.keys(brandInfo).length > 0) {
      const timer = setTimeout(() => {
        container.scrollTop = 10;

        setTimeout(() => {
          container.scrollTop = 0;
          setCurrentStep(1); // Force step 1 to be active
        }, 100);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [brandInfo, campaignMisc]); // Trigger after data loads

  const validateEmailList = (value) => {
    const emails = value
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email !== "");

    if (emails.length > 5) {
      return "Maximum 5 email addresses allowed";
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    for (let email of emails) {
      if (!emailRegex.test(email)) {
        return `Invalid email format: ${email}`;
      }
    }

    return true;
  };

  const handleConfirmClose = () => {
    setValue("cnf_emails", ""); // Clear the email field
    methods.clearErrors("cnf_emails"); // Clear any validation errors
    toggleConfirm();
  };

  // const handleattribute = async () => {
  //   try {
  //     setIsloading(true);
  //     const data = getValues();
  //     const smpl_msgs = data?.campaign_details?.camp_desc?.smpl_msgs ?? [];

  //     const siteid = JSON.parse(
  //       sessionStorage.getItem("admin_session")
  //     )?.siteid;

  //     const requestPayload = { smpl_msgs: smpl_msgs, siteId: siteid };
  //     console.log("Payload sent to backend:", JSON.stringify(requestPayload));
  //     const response = await getSMSAttributes(requestPayload);

  //     console.log("Raw response::::", response);

  //     const saveResp =
  //       typeof response === "object" && !response.json
  //         ? response
  //         : await response.json();

  //     console.log("Parsed saverepeMsg::::", JSON.stringify(saveResp));

  //     if (saveResp.success && saveResp.airesponse?.enable_keys) {
  //       // Store AI results in state
  //       setAiResults({
  //         embedded_link: saveResp.airesponse.enable_keys.embedded_link || false,
  //         embedded_phnum:
  //           saveResp.airesponse.enable_keys.embedded_phnum || false,
  //         age_gated: saveResp.airesponse.enable_keys.age_gated || false,
  //       });

  //       // Update form values with AI results
  //       setValue(
  //         "campaign_details.embed_link",
  //         saveResp.airesponse.enable_keys.embedded_link || false,
  //         { shouldDirty: true }
  //       );
  //       setValue(
  //         "campaign_details.embed_phno",
  //         saveResp.airesponse.enable_keys.embedded_phnum || false,
  //         { shouldDirty: true }
  //       );
  //       setValue(
  //         "campaign_details.age_content",
  //         saveResp.airesponse.enable_keys.age_gated || false,
  //         { shouldDirty: true }
  //       );

  //       // Open AI Review Summary modal
  //       setaiReviewSummary(true);
  //     } else {
  //       // If AI check fails or no results, proceed to confirmation
  //       toggleConfirm();
  //     }
  //   } catch (err) {
  //     console.error("Error in handleattribute:", err);
  //     // On error, proceed to confirmation
  //     toggleConfirm();
  //   } finally {
  //     setIsloading(false);
  //   }
  // };

  // Form-level Tab key handler.
  // MDB Modal adds a window-level keydown listener that intercepts ALL Tab presses
  // and calls preventDefault(), preventing natural focus movement. It builds a
  // static element list at modal-open time that includes inputs from hidden panes,
  // so focus appears stuck.
  // Calling e.stopPropagation() on Tab prevents the event from reaching MDB Modal's
  // window listener; the browser then handles natural Tab movement within the form.
  const handleTabKeyNavigation = (e) => {
    if (e.key !== 'Tab') return;
    e.stopPropagation();
  };

  return (
    <FormProvider {...methods}>
      <div className="min-h-screen bg-gray-50" onKeyDown={handleTabKeyNavigation}>
        <MDBContainer fluid className="p-0">
          {/* Progress Steps */}
          <div className="tnp-modal">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <h4 className="tnp-title">SMS Compliance Registration</h4>
                <p className="tnp-subtitle">
                  Complete the steps below to register your SMS campaign
                </p>
              </div>
              <div className="d-flex align-items-center gap-5">

                <a target="_blank" rel="noopener noreferrer" className="text-decoration-underline fw-bold" href={`${api_serverUrl}docs/pdfs/SMS_Registration.pdf`}>
                  <MDBIcon fas icon="question-circle" className="me-1" color="primary" />
                  Help
                </a>
                <MDBIcon
                  fas
                  icon="times"
                  size="lg"
                  onClick={(e) => {
                    e.preventDefault();
                    handleClose();
                  }}
                  className="cursor-pointer"
                />
              </div>
            </div>

            <MDBScrollspy container={containerRef}>
              <div className="tnp-steps pt-2">
                {/* Step 1 - Business Registration */}
                <MDBScrollspyLink
                  targetRef={section1}
                  onActivate={() => setCurrentStep(1)}
                  tabIndex="-1"
                >
                  <div
                    className={`tnp-step p-2 ${currentStep >= 1
                      ? "bg-primary text-dark bg-opacity-25"
                      : ""
                      } rounded-5`}
                  >
                    <div
                      className={`tnp-icon ${isStep1Complete()
                        ? "tnp-icon--done"
                        : currentStep === 1
                          ? "tnp-icon--active"
                          : ""
                        }`}
                    >
                      {isStep1Complete() ? (
                        <MDBIcon fas icon="check" className="white" size="lg" />
                      ) : (
                        "1"
                      )}
                    </div>
                    <div className="tnp-labels">
                      <div className="tnp-label">Business Registration</div>
                    </div>
                  </div>
                </MDBScrollspyLink>
                <div className="tnp-connector" />

                {/* Step 2 - Campaign Details */}
                <MDBScrollspyLink
                  targetRef={section2}
                  onActivate={() => setCurrentStep(2)}
                  tabIndex="-1"
                >
                  <div
                    className={`tnp-step p-2 ${currentStep >= 2
                      ? "bg-primary text-dark bg-opacity-25"
                      : ""
                      } rounded-5`}
                  >
                    <div
                      className={`tnp-icon ${isStep2Complete()
                        ? "tnp-icon--done"
                        : currentStep === 2
                          ? "tnp-icon--active"
                          : ""
                        }`}
                    >
                      {isStep2Complete() ? (
                        <MDBIcon fas icon="check" className="white" size="lg" />
                      ) : (
                        "2"
                      )}
                    </div>
                    <div className="tnp-labels">
                      <div className="tnp-label">SMS Campaign Details</div>
                    </div>
                  </div>
                </MDBScrollspyLink>
                <div className="tnp-connector" />

                {/* Step 3 - Phone Numbers */}
                <MDBScrollspyLink
                  targetRef={section3}
                  onActivate={() => setCurrentStep(3)}
                  tabIndex="-1"
                >
                  <div
                    className={`tnp-step p-2 ${currentStep >= 3
                      ? "bg-primary text-dark bg-opacity-25"
                      : ""
                      } rounded-5`}
                  >
                    <div
                      className={`tnp-icon ${isStep3Complete()
                        ? "tnp-icon--done"
                        : currentStep === 3
                          ? "tnp-icon--active"
                          : ""
                        }`}
                    >
                      {isStep3Complete() ? (
                        <MDBIcon fas icon="check" className="white" size="lg" />
                      ) : (
                        "3"
                      )}
                    </div>
                    <div className="tnp-labels">
                      <div className="tnp-label">Phone Numbers</div>
                    </div>
                  </div>
                </MDBScrollspyLink>
                <div className="tnp-connector" />

                {/* Step 4 - Confirmation */}
                <MDBScrollspyLink
                  targetRef={section4}
                  onActivate={() => setCurrentStep(4)}
                  tabIndex="-1"
                >
                  <div
                    className={`tnp-step p-2 ${currentStep >= 4
                      ? "bg-primary text-dark bg-opacity-25"
                      : ""
                      } rounded-5`}
                  >
                    <div
                      className={`tnp-icon ${isStep4Complete()
                        ? "tnp-icon--done"
                        : currentStep === 4
                          ? "tnp-icon--active"
                          : ""
                        }`}
                    >
                      {isStep4Complete() ? (
                        <MDBIcon fas icon="check" className="white" size="lg" />
                      ) : (
                        "4"
                      )}
                    </div>
                    <div className="tnp-labels">
                      <div className="tnp-label">Confirm & Submit</div>
                    </div>
                  </div>
                </MDBScrollspyLink>
              </div>
            </MDBScrollspy>
          </div>

          <div className="pe-2  pt-2" style={{ overflowY: "auto" }}>
            <div id="element" ref={containerRef} className="campgain-scrollspy">
              {/* Section 1: Business Registration */}
              <section ref={section1} id="section-1" className="mb-4">
                <MDBCard className="mb-4 bg-transparent container p-0 rounded-6">
                  <MDBCardBody className="bg-info bg-opacity-25 rounded-6">
                    <h5 className="mb-2">SMS Compliance</h5>
                    <p>
                      The Campaign Registry (TCR) will review the website used
                      during registration for certain criteria. If your website
                      is not compliant, your registrations may be rejected,
                      leading to additional fees. Before you start check that
                      your website:
                    </p>
                    <ul className="mb-0 ms-3">
                      <li>
                        Is fully functional and appropriately age-gated if
                        needed.
                      </li>
                      <li>
                        Contains opt-in messaging that tells subscribers how
                        their number will be used.
                      </li>
                      <li>
                        Contains a compliant and easily-accessible privacy
                        policy and SMS Disclaimer.
                      </li>
                      <li>
                        Tip: Make sure that all data collection forms on your
                        website contain a link to your privacy policy.
                      </li>
                    </ul>
                  </MDBCardBody>
                </MDBCard>

                <BusinessRegistrationForm
                  brandInfo={brandInfo}
                  setShowFullForm={setShowFullForm}
                  showFullForm={showFullForm}
                  onWebsiteChange={handleWebsiteChange}
                  onBrandChange={handleBrandChange}
                  onBrandNameChange={handleBrandNameChange}
                />
              </section>

              {/* Section 2: Campaign Details */}
              <section ref={section2} id="section-2" className="my-4">
                <MDBCard className="container rounded-6 shadow-3-strong">
                  <MDBCardBody className="py-4">
                    <h4 className="mb-3 text-center">SMS Campaign Details</h4>
                    <SmsCampaignForm
                      campaignMisc={campaignMisc}
                      draftDetails={draftDetails}
                      websiteForReplacement={websiteForReplacement}
                      brandNameForReplacement={brandNameForReplacement}
                      allLocations={allLocations}
                      billingGroupList={billingGroupList}
                    />
                  </MDBCardBody>
                </MDBCard>
              </section>

              {/* Section 3: Phone Numbers */}
              <section ref={section3} id="section-3" className="my-4">
                <MDBCard className="container rounded-6 shadow-3-strong">
                  <MDBCardBody className="py-4">
                    <SMSCampaignPhoneNumber
                      phoneNumList={phoneNumList}
                      currentStep={currentStep}
                      setCurrentStep={setCurrentStep}
                      defaultBulkMode={!!(draftDetails?.ph_numbers?.bulk_phnums?.length)}
                      draftBulkPhnums={draftDetails?.ph_numbers?.bulk_phnums || []}
                    />
                  </MDBCardBody>
                </MDBCard>
              </section>

              {/* Section 4: Confirm and Submit */}
              <section ref={section4} id="section-4" className="my-4">
                <MDBCard className="container rounded-6 shadow-3-strong border-0">
                  <MDBCardBody className="py-4 px-3 px-md-4">
                    <MDBTypography tag="h4" className="mb-3 text-center">
                      Confirm &amp; Submit
                    </MDBTypography>

                    {/* Agreement row */}
                    <div className="rounded-4 border   p-3 p-md-4 mb-4">
                      <div className="d-flex align-items-start gap-3">
                        <MDBCheckbox
                          id="terms"
                          checked={watch("terms") || false}
                          onChange={(e) =>
                            setValue("terms", e.target.checked, {
                              shouldDirty: true,
                            })
                          }
                          className="mt-1 flex-shrink-0"
                        />
                        <label htmlFor="terms" className="form-check-label m-0">
                          I accept the terms and conditions outlined in the{" "}
                          <a
                            href=""
                            onClick={(e) => {
                              e.preventDefault();
                              window.open(
                                msaURL,
                                "_blank",
                                "width=1000,height=600,scrollbars=yes,resizable=yes",
                              );
                            }}
                          >
                            PanTerra End User Service Agreement
                          </a>{" "}
                          and verify public notice of the following policies are
                          in place.
                        </label>
                      </div>
                    </div>

                    {/* Policies (clean, sectioned) */}
                    <MDBListGroup className="mb-4">
                      <MDBListGroupItem className="py-3">
                        <div className="d-flex align-items-start">
                          <MDBIcon icon="shield-alt" className="me-3 mt-1" />
                          <div>
                            <MDBTypography tag="h5" className="mb-1">
                              Privacy Policy
                            </MDBTypography>
                            <p className="mb-0 text-muted">
                              No mobile information will be shared with third
                              parties/affiliates for marketing or promotional
                              purposes. All the above categories exclude text
                              messaging originator opt-in data and consent; this
                              information will not be shared with any third
                              parties.
                            </p>
                          </div>
                        </div>
                      </MDBListGroupItem>

                      <MDBListGroupItem className="py-3">
                        <div className="d-flex align-items-start">
                          <MDBIcon icon="sms" className="me-3 mt-1" />
                          <div>
                            <MDBTypography tag="h5" className="mb-1">
                              SMS Disclaimer
                            </MDBTypography>
                            <p className="mb-0 text-muted">
                              By providing a telephone number and submitting the
                              form you are consenting to be contacted by SMS
                              text message (message frequency may vary). Message
                              &amp; data rates may apply. Reply{" "}
                              <strong>STOP</strong> to opt-out of further
                              messaging. Reply <strong>HELP</strong> for more
                              information. See our Privacy Policy.
                            </p>
                          </div>
                        </div>
                      </MDBListGroupItem>
                    </MDBListGroup>

                    <div className="d-flex gap-2 justify-content-end">
                      <MDBBtn
                        disabled={Object.keys(dirtyFields ?? {}).length === 0}
                        color="secondary"
                        outline
                        onClick={onSaveDraft}
                        type="button"
                      >
                        <MDBIcon far icon="save" className="me-2" />
                        {/* {"Save as draft"} */}
                        <span style={{ textTransform: "initial" }}>
                          {" "}
                          Save as Draft{" "}
                        </span>
                      </MDBBtn>

                      <MDBBtn
                        disabled={!watch("terms")}
                        onClick={async (e) => {
                          e.preventDefault();
                          // const isValid = await methods.trigger();

                          // if (isValid) {
                          // If validation passes, show confirmation dialog
                          // toggleConfirm();
                          // handleattribute()
                          handleSubmit(onSubmit(false, 1), onError)();
                          // setaiReviewSummary(true);
                          // }
                        }}
                      >
                        <MDBIcon icon="paper-plane" className="me-2" />
                        {"Submit"}
                      </MDBBtn>
                    </div>
                  </MDBCardBody>
                </MDBCard>
              </section>
            </div>
          </div>
        </MDBContainer>

        {/* Modals and Alerts */}
        <MDBModal open={isOpen} setShow={setisOpen} tabIndex="-1">
          <MDBModalDialog>
            <MDBModalContent className="small-popup h-auto">
              <MDBModalHeader>
                <MDBModalTitle>{t("Warning")}</MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={(e) => {
                    e.preventDefault();
                    setisOpen(false);
                  }}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                  <MDBIcon
                    fas
                    icon="question-circle"
                    className="me-3 fs-5 mt-1"
                    color="warning"
                  />
                  <div>
                    You have some unsaved data. Click Save button to save
                    changes.
                  </div>
                </div>
              </MDBModalBody>
              <MDBModalFooter className="d-flex justify-content-between w-100">
                <MDBBtn
                  color="secondary"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    reset();
                    handleFinish();
                  }}
                >
                  Discard Changes
                </MDBBtn>
                <div className="d-flex">
                  <MDBBtn
                    color="secondary"
                    className="me-2"
                    onClick={(e) => {
                      e.preventDefault();
                      openPopup();
                    }}
                  >
                    {t("cancel")}
                  </MDBBtn>
                  {isChanged && (
                    <MDBBtn
                      onClick={(e) => {
                        e.preventDefault();
                        handClose();
                      }}
                    >
                      {t("save")}
                    </MDBBtn>
                  )}
                </div>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>

        {/* SMS Status Alert Modal */}
        <SMSStatusAlert
          isOpen={showStatusAlert}
          onClose={() => setShowStatusAlert(false)}
          status={statusAlertType}
          campaignData={selectedCampaign}
          handleAnyWaySubmit={handleAnyWaySubmit}
          websiteVerificationStatus="verified"
        />

        {successMessage && (
          <MDBAlert
            open
            className="alert-center"
            color="success"
            autohide
            position="bottom-right"
            delay={5000}
            onClose={() => setSuccessMessage("")}
          >
            <i className="fa-solid fa-circle-check me-2"></i>
            <span className="alert-msg">{successMessage}</span>
          </MDBAlert>
        )}

        {isloading && (
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        )}

        {warningAlert && (
          <PopupLoader
            title="Alert"
            content={
              <>
                <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                  <MDBIcon
                    fas
                    icon="exclamation-triangle"
                    className="me-3 fs-5 mt-1"
                    color="warning"
                  />
                  <div>{warningAlertMessage}</div>
                </div>
                <MDBModalFooter>
                  <MDBBtn
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      navigate("/smslanding", {
                        state: { tab: "tab3" },
                      });
                      window.location.reload();
                    }}
                  >
                    {t("ok")}
                  </MDBBtn>
                </MDBModalFooter>
              </>
            }
            onShow={setwarningAlert}
            onClose={(e) => {
              e.preventDefault();
              navigate("/smslanding", {
                state: { tab: "tab3" },
              });
              window.location.reload();
            }}
          />
        )}
        {failureAlert && (
          <PopupLoader
            title="Alert"
            content={
              <>
                <div className="d-flex bg-warning bg-opacity-25 p-3 rounded-3 square border border-2 border-warning">
                  <MDBIcon
                    fas
                    icon="exclamation-triangle"
                    className="me-3 fs-5 mt-1"
                    color="warning"
                  />
                  <div>{FailureMessage}</div>
                </div>
                <MDBModalFooter>
                  <MDBBtn color="secondary" onClick={toggleFailure}>
                    Close
                  </MDBBtn>
                  <MDBBtn
                    color="primary"
                    onClick={(e) => {
                      e.preventDefault();
                      toggleFailureConfirm();
                    }}
                  >
                    Submit Anyway
                  </MDBBtn>
                </MDBModalFooter>
              </>
            }
            onShow={setfailureAlert}
            onClose={toggleFailure}
          />
        )}

        {failureconfirm && (
          <PopupLoader
            title="Alert"
            content={
              <>
                <div className="pb-2 d-flex flex-column h-100">
                  <div className="text-center mb-4 flex-grow-1">
                    <p className="m-0">
                      Proceeding with this action will bypass website
                      verification.
                    </p>
                    <h4 className="m-0"> Are you sure you want to continue?</h4>
                  </div>
                  <div className="text-center">
                    <b>Note:</b> Bypassing verification may cause TCR to reject
                    the campaign.
                  </div>
                </div>
                <MDBModalFooter className="pe-0 pb-0">
                  <MDBBtn onClick={toggleFailureConfirm} color="secondary">
                    {t("cancel")}
                  </MDBBtn>
                  <MDBBtn
                    onClick={(e) => {
                      e.preventDefault();
                      handleAnyWaySubmit();
                    }}
                  >
                    {t("Proceed")}
                  </MDBBtn>
                </MDBModalFooter>
              </>
            }
            onShow={setfailureConfirm}
            onClose={toggleFailureConfirm}
          />
        )}

        <MDBModal
          tabIndex="-1"
          open={aiReviewSummary}
          setOpen={setaiReviewSummary}
          className="ai-review-modal"
        >
          <MDBModalDialog centered size="lg">
            <SampeAIChecksPOPUP
              aiResults={aiResults}
              setAiResults={setAiResults}
              brandid={watch("brand_id")}
              onClose={(e) => {
                // e.preventDefault();
                setaiReviewSummary(false);
              }}
              OnDone={(e) => {
                e.preventDefault();
                setaiReviewSummary(false);
                setValue(
                  "campaign_details.embed_link",
                  aiResults.embedded_link,
                  { shouldDirty: true },
                );
                setValue(
                  "campaign_details.embed_phno",
                  aiResults.embedded_phnum,
                  { shouldDirty: true },
                );
                setValue(
                  "campaign_details.age_content",
                  aiResults.age_gated,
                  { shouldDirty: true },
                );
                if (watch("brand_id")) {
                  handleSubmit(onSubmit(false, 0))();
                } else {
                  toggleConfirm();
                }
              }}
            />
          </MDBModalDialog>
        </MDBModal>

        {confirmAlert && (
          <PopupLoader
            title="Alert"
            content={
              <>
                <label htmlFor="" className="fw-bold">
                  Email for notifications
                </label>
                <p className="text-secondary">
                  Enter up to 5 comma-separated email addresses.
                </p>
                <Controller
                  name="cnf_emails"
                  control={methods.control}
                  defaultValue=""
                  rules={{
                    validate: validateEmailList,
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <>
                      <TextareaAutosize
                        {...field}
                        id="cnf_emails"
                        minRows={3}
                        maxRows={6}
                        placeholder="e.g., user1@example.com, user2@example.com"
                        className={`w-100 form-control ${error ? "is-invalid" : ""
                          }`}
                      />
                      {error && (
                        <p className="text-danger mt-2 mb-0">
                          <MDBIcon
                            fas
                            icon="info-circle"
                            color="danger"
                            className="me-1"
                          />
                          {error.message}
                        </p>
                      )}
                    </>
                  )}
                />
                <div className="py-2 text-center">
                  <p className="mb-2">
                    By submitting, the provided website will be verified using
                    an AI tool for Privacy Policy and SMS Disclaimer. You will
                    be redirected to the Drafts page, where the website
                    verification will be in progress. This process may take a
                    few minutes to complete. A notification email will be sent
                    once the verification is completed or fails.
                  </p>
                  <h4> Are you sure you want to proceed?</h4>
                </div>
                <MDBModalFooter className="pe-0 pb-0">
                  <MDBBtn onClick={handleConfirmClose} color="secondary">
                    {t("cancel")}
                  </MDBBtn>
                  <MDBBtn
                    onClick={async (e) => {
                      e.preventDefault();
                      const isEmailValid = await methods.trigger("cnf_emails");

                      if (isEmailValid) {
                        toggleConfirm();
                        handleSubmit(onSubmit(false, 0))();
                      }
                    }}
                  >
                    {t("Proceed")}
                  </MDBBtn>
                </MDBModalFooter>
              </>
            }
            onShow={setconfirmAlert}
            onClose={handleConfirmClose}
          />
        )}
      </div>
    </FormProvider>
  );
}
